import React from 'react';
import { useIntl } from '@godaddy/react-mintl';
import PropTypes from 'prop-types';

import Link from '@ux/link';
import AsyncIcon from '@ux/icon/async-icon.js';

import { useRootProps } from './UserDataProvider';

import './HelpLink.css';

const HelpLink = ({ appEid, helpUrl }) => {
  const { formatMessage } = useIntl();
  const { urls } = useRootProps();

  const helpHref = helpUrl?.href || urls?.help.href;
  const target = helpUrl?.target || '_self';

  const pageEid = appEid.extend('help');
  const helpLinkEid = pageEid('help_link.link.click') || '';

  const messages = {
    helpLinkText:
      formatMessage({ id: 'SIDEBAR_HELP' })
  };

  return (
    <Link href={ helpHref } target={ target } className='global-help-link' data-eid={ helpLinkEid } aria-label={ messages.helpLinkText }>
      <span>{messages.helpLinkText}</span>
      <AsyncIcon icon='help' />
    </Link>
  );
};

HelpLink.propTypes = {
  appEid: PropTypes.func,
  helpUrl: PropTypes.shape({
    href: PropTypes.string,
    target: PropTypes.string
  })
};

export default HelpLink;
